import sha256 from "js-sha256"

/* Never change salt or algorithm or the calculated hashes will not match with the hashes in the database */
const salt = "i4u5wHW?Y85P[Lb-.j1x3be{E_Ci10F"

export default function hash(text) {
  return sha256(text + salt)
}
